import { useNavigate, Link } from "react-router-dom";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();

  const productSlug = product.name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

  const handleInquire = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate("/contact", {
      state: {
        productName: product.name,
        message: `I would like to inquire about ${product.name}. Please provide more details about pricing, availability, and specifications.`,
      },
    });
  };

  return (
    <div className="product-card">
      <Link to={`/products/${productSlug}`} className="product-card-link">
        <div className="product-image">
          {product.image && (
            <img src={product.image} alt={product.name} loading="lazy" />
          )}
        </div>
        <div className="product-info">
          <div className="product-name">{product.name}</div>
          <div className="product-price">{product.price}</div>
          <div className="product-description">{product.description}</div>
        </div>
      </Link>
      <div className="product-card-actions">
        <Link
          to={`/products/${productSlug}`}
          className="view-details-btn"
        >
          View Details
        </Link>
        <button className="inquire-btn" onClick={handleInquire}>
          Get Quote
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
